const fetchFn = async (url: string, options: any) => {
    const res = await fetch(url, options);
    return res.json();
};


const useGet = async (url: string, options: any) => {
    return await fetchFn(url, options);
};


const usePut = async (url: string, tokenHeader: any, body?: any) => {
    const options = {
        headers: {...tokenHeader.headers},
        method: 'PUT',
        body: JSON.stringify(body)
    };
    return await fetchFn(url, options);

};

const usePost = async (url: string, tokenHeader: any, body?: any) => {
    const options = {
        headers: {...tokenHeader.headers},
        method: 'POST',
        body: JSON.stringify(body)
    };
    return await fetchFn(url, options);
};

// Wrapper fetch che permette di controllare dapprima se il token è ancora valido, richiedendone il token aggiornato.
// Richiama la fetch presente nella callback.

const refreshToken = async (keycloak: Keycloak.KeycloakInstance) => {

    return new Promise<Keycloak.KeycloakInstance>((resolve, reject) => {

        keycloak.updateToken(5).then(function () {
            resolve(keycloak)
        }).catch(function () {
            reject(keycloak)
        });
    });
};


const authFetch = async (kc: Keycloak.KeycloakInstance, callback: (kc: Keycloak.KeycloakInstance, args?: any)=>Promise<any>,
                   args?: any) => {

        try {
            const kcU: Keycloak.KeycloakInstance = await refreshToken(kc);
            return callback(kcU, args);
        } catch (e) {
            console.log("Error");
            kc.login();
        }
};

interface PropsApi {
    url: string;
    token?: Keycloak.KeycloakInstance;
    body?: any;
    method: string;
    contentType?: string;
    acceptType?: string;
}



interface FetchInterface {
    get: (props: PropsApi) => Promise<any>;
    put: (props: PropsApi) => Promise<any>;
    post: (props: PropsApi) => Promise<any>;
    head: (props: PropsApi) => Promise<any>;
    delete: (props: PropsApi) => Promise<any>;
}




export {
    useGet,
    usePost,
    usePut,
    authFetch
}